import DataPill from "@components/pills/DataPill";
import React from "react";

interface AffiliateStatusPill {
  statusText: string;
}

const AffiliateStatusComponent: React.FC<AffiliateStatusPill> = ({
  statusText,
}) => {
  return <DataPill value={statusText} label={statusText} />;
};

export default AffiliateStatusComponent;
